import AdditionalInfoSection from './AdditionalInfoSection';

export default AdditionalInfoSection;
